import styled from "styled-components";

export const ContainerGroups = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContainerGroup = styled.div`
  display: flex;
  width: 100%;
`;

export const ContainerLogo = styled.div`
  max-width: 70px;
  width: 100%;
  display: flex;
  align-items: flex-start;
`;

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  height: 100%;
  font-family: "Roboto";
  font-style: normal;
  color: #333333;
  margin-bottom: 15px;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;

export const SubTitle = styled.div`
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
`;

export const Topic = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
`;

export const SubTopic = styled.div`
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
`;

export const Description = styled.div`
  font-style: italic;
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
  color: #333333;
  text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
`;

export const ContainerDescriptionTopic = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  height: 100%;
  font-family: "Roboto";
  font-style: normal;
  color: #333333;
  margin-bottom: 20px;
`;
